import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { StaticImage } from "gatsby-plugin-image";
import sOne from "../../../images/case-studies/schology/slider-1.webp";
import sTwo from "../../../images/case-studies/schology/slider-2.webp";
import sThree from "../../../images/case-studies/schology/slider-3.webp";

function Schologyslider() {
  const [activeIndex, setActiveIndex] = useState(0);

  const backgroundImages = [sOne, sTwo, sThree];
  return (
    <section
      className="schology-slider p-100"
      style={{
        backgroundImage: `url(${
          backgroundImages[activeIndex % backgroundImages.length]
        })`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        transition: "background-image 0.5s ease-in-out",
      }}
    >
      <Swiper
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        // autoplay={false}
        spaceBetween={10}
        modules={[Autoplay]}
        onSlideChange={(swiper) => {
          setActiveIndex(swiper.realIndex);
        }}
        breakpoints={{
          320: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 2,
          },
          1200: {
            slidesPerView: 3,
          },
          1600: {
            slidesPerView: 3,
          },
        }}
        className="schology-slider-portfolio"
      >
        <SwiperSlide>
          <div className="slider-img">
            <StaticImage
              src="../../../images/case-studies/schology/slider-1.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={682}
              height={510}
            />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slider-img">
            <StaticImage
              src="../../../images/case-studies/schology/slider-2.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={682}
              height={510}
            />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slider-img">
            <StaticImage
              src="../../../images/case-studies/schology/slider-3.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={682}
              height={510}
            />
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="slider-img">
            <StaticImage
              src="../../../images/case-studies/schology/slider-1.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={682}
              height={510}
            />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slider-img">
            <StaticImage
              src="../../../images/case-studies/schology/slider-2.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={682}
              height={510}
            />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slider-img">
            <StaticImage
              src="../../../images/case-studies/schology/slider-3.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={682}
              height={510}
            />
          </div>
        </SwiperSlide>
      </Swiper>
    </section>
  );
}

export default Schologyslider;
